import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { noop } from 'Helpers/PropTypes';

export const COLORS = [
  'primary',
  'gray',
];

export const SIZES = [
  'large',
  'medium',
  'small',
];

const styles = (theme) => ({
  root: {
    backgroundColor: theme.palette.facet.accentBlue21,
  },
  primary: {
    color: theme.palette.primary,
    backgroundColor: theme.palette.accentBlue21,
  },
  gray: {
    color: theme.palette.lightGray,
    backgroundColor: theme.palette.primary,
  },
  large: {
    fontSize: theme.typography.pxToRem(35),
  },
  medium: {
    // Default MUI size of 1.5rem
  },
  small: {
    fontSize: theme.typography.pxToRem(20),
  },
});

const PreviousButton = ({
  className,
  classes,
  onClick,
  disabled,
  color,
  size,
  test,
}) => {
  return (
    <IconButton
      onClick={onClick}
      className={classNames(classes.root, className, classes[color], classes[size])}
      aria-label={'go back button'}
      title={'Go Back'}
      icon={NavigateBeforeIcon}
      size={size}
      disabled={disabled}
      test={test}
    />
  );
};

PreviousButton.defaultProps = {
  className: '',
  disabled: false,
  color: 'primary',
  size: 'large',
  onClick: noop,
  test: undefined,
};

PreviousButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  color: PropTypes.oneOf(COLORS),
  size: PropTypes.oneOf(SIZES),
  test: PropTypes.string,
};

export default withStyles(styles)(PreviousButton);
